"use client";

import { c as _c } from "react/compiler-runtime";
import { clsx } from "@/helpers/clsx";
import { Bars3BottomLeftIcon } from "@heroicons/react/24/outline";
import React from "react";
const useScrollSpy = (items, options) => {
  const $ = _c(5);
  const [activeId, setActiveId] = React.useState("");
  let t0;
  if ($[0] !== items || $[1] !== options) {
    t0 = () => {
      const intersectingElements = new Map();
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            intersectingElements.set(entry.target.id, entry);
          } else {
            intersectingElements.delete(entry.target.id);
          }
        });
        const sortedEntries = [...intersectingElements.values()].sort(_temp);
        const isScrolledToBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight;
        const firstEntry = sortedEntries[isScrolledToBottom ? "findLast" : "find"](_temp2);
        if (!firstEntry) {
          return;
        }
        setActiveId(firstEntry?.target.id || "");
      }, options);
      items.forEach(id => {
        if (!id) {
          return;
        }
        const element = document.getElementById(id);
        if (element) {
          observer.observe(element);
        }
      });
      return () => observer.disconnect();
    };
    $[0] = items;
    $[1] = options;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== options) {
    t1 = [options];
    $[3] = options;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  React.useEffect(t0, t1);
  return activeId;
};
export const TableOfContents = t0 => {
  const $ = _c(11);
  const {
    headings
  } = t0;
  let t1;
  if ($[0] !== headings) {
    t1 = headings?.map(_temp3) ?? [];
    $[0] = headings;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      rootMargin: "0px 0px 0px 0px",
      threshold: 1
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const activeId = useScrollSpy(t1, t2);
  if (!headings) {
    return null;
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h3 className="m-0 mb-1 flex items-center gap-x-2 text-[13px] leading-[1.5] text-gray-400 xl:-ml-0.5"><Bars3BottomLeftIcon className="size-3.5" />On this page</h3>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== activeId || $[5] !== headings) {
    let t5;
    if ($[7] !== activeId) {
      t5 = t6 => {
        const {
          level,
          title,
          id
        } = t6;
        const visible = activeId === id;
        return <a key={id} href={`#${id}`} style={{
          paddingLeft: `${20 + level * 16}px`
        }} className={clsx("group relative cursor-pointer py-0.5 no-underline transition-colors hover:text-primary-300 xl:-ml-0.5", visible && "!text-primary decoration-primary")}><span className={clsx("absolute inset-y-0 left-0 hidden h-full w-0.5 bg-primary group-hover:flex group-hover:opacity-50", visible && "flex !opacity-100")} />{title}</a>;
      };
      $[7] = activeId;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = headings.map(t5);
    $[4] = activeId;
    $[5] = headings;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <div className="not-prose pointer-events-none inset-0 xl:absolute"><div className="z-2 pointer-events-auto sticky right-0 top-28 mt-6 flex flex-col gap-y-1 rounded-md border border-neutral-800 p-4 px-6 text-sm backdrop-blur-sm xl:left-[100%] xl:mt-2 xl:w-[300px] xl:rounded-r-none xl:border-0 xl:border-r-0 xl:p-0 xl:text-[13px]">{t3}<div className="relative flex flex-col xl:border-l-[2px] xl:border-neutral-800 xl:pr-4">{t4}</div></div></div>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
function _temp(a, b) {
  return a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top;
}
function _temp2(e) {
  return e.isIntersecting;
}
function _temp3(h) {
  return h.id;
}